import { alpha, SliderTrack, styled } from '@mui/material';
import { grey } from '@mui/material/colors';

export const SliderTrackStyled = styled(SliderTrack)({
  backgroundColor: 'transparent',
  borderTopWidth: 0,
  borderBottomWidth: 0,
  transition: 'none',
});

export const SliderTrackOverlay = styled('div')({
  position: 'absolute',
  top: 0,
  bottom: 0,
  backgroundColor: alpha(grey[100], 0.75),
});
